import MarketingMaterialSampleModal, {
  MARKETING_MATERIAL_SAMPLE_MODAL,
} from './modal';

export { MARKETING_MATERIAL_SAMPLE_MODAL };

export default MarketingMaterialSampleModal;
